import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLogo = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 0,
	height: 0,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props
});
const ForwardRef = forwardRef(SvgLogo);
export default ForwardRef;
